module.exports = __webpack_public_path__ + "img/chilioil-system2.75ff0396.png";